import { render, staticRenderFns } from "./clientInformationForm.vue?vue&type=template&id=8bac317a"
import script from "./clientInformationForm.vue?vue&type=script&lang=js"
export * from "./clientInformationForm.vue?vue&type=script&lang=js"
import style0 from "./clientInformationForm.vue?vue&type=style&index=0&id=8bac317a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports